import { memoizedCatalogData } from 'bundles/catalogP/api/api.promise';
import catalogUrl from 'bundles/catalogP/lib/catalogUrl';
import CourseProgress from 'bundles/catalogP/models/courseProgress';

export default function (options: $TSFixMe, memoizeOptions: $TSFixMe) {
  if (memoizeOptions && memoizeOptions.forceUpdate) {
    return memoizedCatalogData.force(catalogUrl.build(CourseProgress.prototype.resourceName, options));
  } else {
    return memoizedCatalogData(catalogUrl.build(CourseProgress.prototype.resourceName, options));
  }
}
